module.exports = __webpack_public_path__ + "6218b1879043f8163512e8037d8943b4.pdf";